import React from 'react'

function Experiences() {
  return (
    <div className='dark-con'>
        <h2>Academic Background</h2>
        <div >
            <img className='grayOut' src="e-logos/guvi.png"  height="100px" alt="Guvi" title='GUVI' />
            <img className='grayOut' src="e-logos/ssn.png" height="100px" alt="SSN" title='SSN College of Engineering' />
            <img className='grayOut' src="e-logos/vsvn.png" height="100px" alt="VSVN" title='VSVN Polytechnic college'/>
        </div>
    </div>
  )
}

export default Experiences